import { text } from '#contract'
import { useClient } from '../app/client-context.ts'
import { useView } from '../app/use-view.ts'
import { ProgressScreen } from '../components/progress-screen.tsx'
import { useT } from '../i18n/index.ts'

/** Shown from the first paint until the engine has booted. */
export function BootScreen() {
  const t = useT()
  const attached = useClient() !== null
  const progress = useView((view) => view.boot.progress)
  const label = t(text('boot.loading'))

  return (
    <ProgressScreen
      title={t(text('app.title'))}
      status={label}
      label={label}
      // Indeterminate until the engine chunk has loaded and can report progress.
      value={attached ? progress : null}
    />
  )
}
